import {
  BarChart3,
  Building2,
  CalendarRange,
  CloudUpload,
  CreditCard,
  KeyRound,
  Lightbulb,
  ListChecks,
  Megaphone,
  Rocket,
  ShieldCheck,
  Sparkles,
  Table2,
  UserRound,
  Users,
} from "lucide-react";

export const COMMAND_PAGES = [
  {
    path: "/dashboard/ads",
    label: "Dashboard",
    group: "Overview",
    icon: BarChart3,
    keywords: "ad journey stats",
  },
  {
    path: "/dashboard/ad-request",
    agencyPath: "/dashboard/ad-request/assigned",
    label: "Ad Requests",
    group: "Pipeline",
    icon: Megaphone,
    lookup: true,
  },
  {
    path: "/dashboard/ad-upload",
    label: "Ad Delivery",
    group: "Pipeline",
    icon: CloudUpload,
    lookup: true,
    keywords: "deliveries upload",
  },
  {
    path: "/dashboard/ad-moderation",
    label: "Ad Moderation",
    group: "Pipeline",
    icon: ListChecks,
    lookup: true,
    keywords: "review approve reject",
  },
  {
    path: "/dashboard/ad-launch",
    label: "Ad Launch",
    group: "Pipeline",
    icon: Rocket,
    lookup: true,
    keywords: "meta live auto launch",
  },
  {
    path: "/dashboard/agency_sprints",
    label: "Ad Sprints",
    group: "Planning",
    icon: CalendarRange,
  },
  {
    path: "/dashboard/category-track-mapping",
    label: "Category Track Mapping",
    group: "Setup",
    icon: Table2,
    keywords: "ctm campaigns rotation track",
  },
  {
    path: "/dashboard/ad-rate-card",
    label: "Rate Card",
    group: "Setup",
    icon: CreditCard,
  },
  {
    path: "/dashboard/ad-recco",
    label: "View Recco",
    group: "Setup",
    icon: Lightbulb,
  },
  {
    path: "/dashboard/ad-intelligence",
    label: "Ad Intelligence",
    group: "Insights",
    icon: Sparkles,
    keywords: "taxonomy tags",
  },
  {
    path: "/dashboard/agency-user-roles?tab=agencies",
    label: "Agencies",
    group: "Team",
    icon: Building2,
    hideForAgency: true,
  },
  {
    path: "/dashboard/agency-user-roles?tab=users",
    label: "Users",
    group: "Team",
    icon: Users,
  },
  {
    path: "/dashboard/agency-user-roles?tab=roles",
    label: "Roles",
    group: "Team",
    icon: ShieldCheck,
  },
  {
    path: "/dashboard/agency-user-roles?tab=permissions",
    label: "Permissions",
    group: "Team",
    icon: KeyRound,
  },
  {
    path: "/profile",
    label: "My profile",
    group: "Account",
    icon: UserRound,
  },
];

/** True when every word of the query appears in the text, ignoring case. */
export const handleMatchesQuery = ({ query, text }) => {
  const haystack = (text || "").toLowerCase();
  return query
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => haystack.includes(word));
};
